import template from './dropdown.html';

export class DropdownController {
  constructor(KEY_CODES) {
    'ngInject';

    this.KEY_CODES = KEY_CODES;
    this.isOpen = false;
  }
  open() {
    if (!this.disableDropdown) {
      this.isOpen = true;
    }
  }
  close() {
    this.isOpen = false;
  }
  select(item) {
    this.onSelect({ item });
    this.close();
  }
  keyup($event) {
    if ($event.keyCode === this.KEY_CODES.enter) {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
  }
  isSelected(item) {
    return item[this.itemsIdProperty] === this.selectedItem[this.itemsIdProperty];
  }
  shouldShowThePlaceholder() {
    return this.placeholder &&
      this.showPlaceholder &&
      !this.selectedItem[this.itemsIdProperty];
  }
}

export default {
  controller: DropdownController,
  template,
  bindings: {
    id: '@',
    itemsIdProperty: '@',
    itemsLabelProperty: '@',
    placeholder: '@',
    showPlaceholder: '<',
    items: '<',
    selectedItem: '<',
    onSelect: '&',
    disableDropdown: '<',
    error: '<',
  },
};
